export default "__VITE_ASSET__Cn5LG2uk__"